export default __webpack_public_path__ + "73c2cfc980da94fdf098ba4f84163726.png";